module.exports = __webpack_public_path__ + "static/media/default-image.ac3d59db.svg";